import { render, staticRenderFns } from "./TaskRecurrenceList.vue?vue&type=template&id=7959c38e&"
import script from "./TaskRecurrenceList.vue?vue&type=script&lang=js&"
export * from "./TaskRecurrenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports